import {
  configureStore,
  combineReducers,
  ThunkAction,
  Action,
} from "@reduxjs/toolkit";
import emptySplitApi from "../features/api/emptySplitApi";

import tokenSliceReducer from "../features/token";
export {
  authenticateInternalUser,
  authenticateExternalUser,
  logout,
} from "../features/token";

const reducer = combineReducers({
  api: emptySplitApi.reducer,
  token: tokenSliceReducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer,
    middleware: (gDM) => gDM().concat(emptySplitApi.middleware),
    preloadedState,
  });
};

export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
export type RootState = ReturnType<typeof reducer>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action
>;
